const allBallot = { data: [], loading: true };

export const GetBallot = (state = allBallot, action) => {
  switch (action.type) {
    case "get_ballot":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

const allBallotData = { data: [], loading: true };

export const GetBallotData = (state = allBallotData, action) => {
  switch (action.type) {
    case "get_ballotdata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
